import React from "react";
import { Tag, Tooltip } from "antd";

// Why an uploaded name was matched to a different name (backend lib/matchCategory.js).
// Green: the same plant, safe to trust. The rest are worth a look; red most of all.
const CATEGORIES: Record<string, { color: string; hint: string }> = {
  formatting: { color: "green", hint: "Same taxon; only abbreviation, capitals or spacing changed." },
  infrataxon_added: { color: "green", hint: "The species was matched to its own nominate subspecies or variety." },
  spelling: { color: "blue", hint: "A typo was corrected (same genus, within 2 characters)." },
  synonym: { color: "orange", hint: "This is an older name; it was updated to the currently accepted name." },
  reclassified: { color: "purple", hint: "The name was moved to a different rank or combination." },
  different: { color: "red", hint: "The closest name we found is different. Check it before accepting." },
  common_name: { color: "cyan", hint: "Matched through a common name." },
};

interface Props {
  category?: string | null;
  label?: string | null;
}

const MatchCategoryTag: React.FC<Props> = ({ category, label }) => {
  const meta = category ? CATEGORIES[category] : undefined;
  if (!meta || !label) return null;
  return (
    <Tooltip title={meta.hint}>
      <Tag color={meta.color} style={{ marginLeft: 6 }}>
        {label}
      </Tag>
    </Tooltip>
  );
};

export default MatchCategoryTag;
